import type { Routes } from '@angular/router';

export const unauthorizedRoutes: Routes = [
  {
    path: 'unauthorized',
    loadComponent: () => import('./unauthorized.component').then((m) => m.UnauthorizedComponent),
  },
];
